import { AbstractModel } from '@uzurv/core';
import { autoserialize, autoserializeAs, inheritSerialization } from 'cerialize';
import { TechnologyPlatform } from './technology-platform';

@inheritSerialization(AbstractModel)
export class Provider extends AbstractModel {
  @autoserialize
  name: string;

  @autoserialize
  code: string;

  @autoserialize
  description: string;

  @autoserialize
  phoneNumber: string;

  @autoserialize
  emailAddress: string;

  @autoserialize
  proxyDriverId: number;

  @autoserialize
  onDispatch: boolean;

  @autoserializeAs(TechnologyPlatform)
  technologyPlatform: TechnologyPlatform;

  @autoserialize
  dotsProviderIdentifier: number;
}
